'use strict';
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits$0024$002dRich$002dSource$0024 from "./com.raquo.laminar.api.-Implicits$-Rich-Source$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024 from "./dev.cheleb.scalamigen.-Form$package$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024 from "./dev.cheleb.scalamigen.-Hidden-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024 from "./dev.cheleb.scalamigen.-Shown-Event$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$0024less$0024colon$0024less$0024 from "./scala.$less$colon$less$.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$$anon$9(displaySrc$2, d$4, fa$5, condVar$2, cond$2) {
  this.zo = null;
  this.HF = null;
  this.HG = null;
  this.HE = null;
  this.HD = null;
  this.HC = null;
  this.zo = displaySrc$2;
  this.HF = d$4;
  this.HG = fa$5;
  this.HE = condVar$2;
  this.HD = cond$2;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_Form$$anon$9 as $c_Ldev_cheleb_scalamigen_Form$$anon$9 };
$p = $c_Ldev_cheleb_scalamigen_Form$$anon$9.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$$anon$9;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$$anon$9() {
}
export { $h_Ldev_cheleb_scalamigen_Form$$anon$9 as $h_Ldev_cheleb_scalamigen_Form$$anon$9 };
$h_Ldev_cheleb_scalamigen_Form$$anon$9.prototype = $p;
$p.dJ = (function() {
  return this.HC;
});
$p.dt = (function(x$1) {
  this.HC = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(factory.cX(true, label), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.ev().kG(this.zo, $j_scala$002e$0024less$0024colon$0024less$0024.$m_s_$less$colon$less$().N)]));
});
$p.bt = (function(path, variable, factory, errorBus) {
  var varA = $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var(variable, new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2) => {
    if ((x$1$2 instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
      return x$1$2.Q;
    }
    if (($j_java$002elang$002e$002dObject.$m_s_None$() === x$1$2)) {
      return this.HF.eu();
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$2);
  })), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$2$1, x$2$2) => new $j_java$002elang$002e$002dObject.$c_s_Some(x$2$2))));
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(this.HG.bt(path, varA, factory, errorBus), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.ev().kG(this.zo, $j_scala$002e$0024less$0024colon$0024less$0024.$m_s_$less$colon$less$().N), ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits$0024$002dRich$002dSource$0024.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().NJ($j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$c_Lcom_raquo_airstream_misc_MapSignal(), this.HE.a4(), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2) => {
    if ((!(!this.HD.Bc().j(v$2)))) {
      var $x_1 = $j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ShownEvent$();
    } else {
      if ((!variable.a4().b3().C().k())) {
        $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(variable, $j_java$002elang$002e$002dObject.$m_s_None$());
      }
      var $x_1 = $j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024.$m_Ldev_cheleb_scalamigen_HiddenEvent$();
    }
    var ev = $x_1;
    return new $j_java$002elang$002e$002dObject.$c_T2($j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024.$m_Ldev_cheleb_scalamigen_Form$package$().bF(path), ev);
  })), $j_java$002elang$002e$002dObject.$m_s_None$()), errorBus.fr))]));
});
var $d_Ldev_cheleb_scalamigen_Form$$anon$9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$$anon$9, "dev.cheleb.scalamigen.Form$$anon$9", ({
  j7: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$$anon$9 as $d_Ldev_cheleb_scalamigen_Form$$anon$9 };
